import "./bootstrap";
import "tw-elements";
import "hammerjs";
import $ from 'jquery';
import 'flowbite';
// import { Select, initTE } from "tw-elements";
// initTE({ Select });
// document.addEventListener("resize", function () {}, {
//     passive: true,
//     // passive: true,
// });

document.addEventListener("share", function (event) {
    if (window.navigator.share) {
        event.preventDefault();
        window.navigator.share(event.detail);
    }
});

document.addEventListener("share-fb", function (event) {
    const {url, ...data } = event.detail || {};
    if (url) {
        event.preventDefault();
        event.stopPropagation();
        window.open(
            "https://www.facebook.com/sharer/sharer.php?" + new URLSearchParams({u:url, ...data }),
            "facebook-share-dialog",
            "width=800,height=600"
        );
    return false;
    }
});

document.addEventListener("copy-url", function (event) {
    const url = event.detail?.url;
    if (url) {
        event.preventDefault();
        event.stopPropagation();
        if (navigator.clipboard) {
            // Copy the text inside the text field
            navigator.clipboard.writeText(url);
        } else if (document.execCommand) {
            const copyText = document.createElement("input");
            copyText.value = url;
            document.body.appendChild(copyText);
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices
            document.execCommand("copy");
            document.body.removeChild(copyText);
        }
        return false;
    }
});

function gaLog($event) {
    const $element = $($event.currentTarget);
    const eventAction = $element.data("action");
    const eventCategory = $element.data("category");
    const eventLabel = $element.data("label");
    const eventValue = $element.data("value") || 1;
    console.log("ga send event", {
        eventCategory,
        eventAction,
        eventLabel,
        eventValue,
    });
    if (window.gtag) {
        gtag("event", eventAction, {
            event_category: eventCategory,
            event_label: eventLabel,
            value: eventValue,
        });
    }

    if (window.Livewire) {
        Livewire.emit("ga-event", eventAction, {
            event_category: eventCategory,
            event_label: eventLabel,
            value: eventValue,
        });
    }
}

$(document.body)
    .on("click", '[data-trigger="ga-click"]', gaLog)
    .on("change", '[data-trigger="ga-change"]', gaLog)
    .on("submit", '[data-trigger="ga-submit"]', gaLog);


window.addEventListener("alpine:init", function () {
    const uploadForS3 = async (file, payload, options = {}) => {
            let headers = payload.headers;
            if ('Host' in headers) delete headers.Host;
            options.headers = Object.assign(headers, options.headers);
            const { response } = await axios.put(payload.url, file, options);
            console.log(response);
    }
    Alpine.data("ajaxUpload", () => ({
        loading: false,
        value: "",
        file: {
            url: null,
            name: null,
        },
        progress: 0,
        async startUpload($event) {
            this.loading = true;
            const file = $event.target.files[0];
            this.progress = 0;
            try {
                const uploadTask = (this.file = {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    previewUrl: URL.createObjectURL(file),
                });
                const {
                    data: { success, is_s3, payload },
                } = await axios.post("/api/community/upload", uploadTask);
                debugger;
                this.value = `livewire-file:${payload.path}`;
                const { response } = uploadForS3(file, payload, {
                    onUploadProgress: ({ progress }) => {
                        this.progress = progress * 100;
                    },
                });
                this.progress = 100;
            } finally {
                setTimeout(() => {
                    this.loading = false;
                }, 1e3);
            }
        },
    }));
});
